@if (initialized && model) {
  <div>
    @if (step === 'address') {
      <app-invoice-address
        (next)="onInvoiceAddress($event)"
        (backEvent)="onInvoiceAddressBack()"
        [historyBack]="false"
        >
      </app-invoice-address>
    }
    @if (isSepa && step === 'payment') {
      <app-payment-method
        (next)="onPaymentMethod($event)"
        [onlyEmit]="true"
        (backEvent)="onPaymentMethodBack()"
        [historyBack]="false"
        [paymentMethod]="model?.saleOrder?.payment_method ?? model?.subscription?.payment_method"
        >
      </app-payment-method>
    }
    @if (step === 'checkout') {
      <app-checkout-one-summary
        [subscription]="model.subscription"
        (back)="onSummaryBack()"
        [historyBack]="false"
        (buy)="onBuy()"
        >
      </app-checkout-one-summary>
    }
    @if (step === 'complete') {
      <app-endcustomer-upgrade-order-complete
        (next)="onComplete()"
        >
      </app-endcustomer-upgrade-order-complete>
    }
  </div>
}
